import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export const presenceText = ({ online, lastSeenAt, status, label } = {}) => {
    // Available / Away / In a call / On leave, from a server that knows them.
    if (status && status !== 'offline' && label) return label;
    if (online) return 'Online now';
    if (!lastSeenAt) return 'Last seen unavailable';
    return `Last seen ${lastSeenWhen(lastSeenAt)}`;
};

/*
 * "5:41 PM" today, "5:41 PM yesterday", "5:41 PM, 18 Oct" before that. Never
 * the year: presence older than that is not a "last seen" anyone acts on.
 */
export const lastSeenWhen = (iso, now = new Date()) => {
    const at = new Date(iso);
    const time = at.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (at.toDateString() === now.toDateString()) return time;
    if (at.toDateString() === yesterday.toDateString()) return `${time} yesterday`;
    return `${time}, ${at.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}`;
};

export default function LastSeen({ userId }) {
    const [presence, setPresence] = useState(null);
    useEffect(() => {
        if (!userId) return undefined;
        let cancelled = false;
        setPresence(null);
        const refresh = async () => {
            try {
                const { data } = await api.get(`/employees/${userId}/presence`);
                if (!cancelled) setPresence(data);
            } catch { /* Keep the last successful presence result. */ }
        };
        refresh();
        const timer = setInterval(refresh, 30000);
        return () => { cancelled = true; clearInterval(timer); };
    }, [userId]);
    if (!userId || !presence) return null;
    return <span className="employee-last-seen">{presenceText(presence)}</span>;
}
